// @flow
import * as React from 'react';
import { H1 } from 'components/Heading';
import CenteredLayoutContainer from 'components/CenteredLayoutContainer';
import Layout from './Layout';

const CenteredLayout = ({
  title,
  children
}: {
  title?: string,
  children: React.Node
}) => (
  <Layout defaultWithSearchHero={false}>
    <CenteredLayoutContainer
      pt={[null, null, null, 60]}
      pb={[null, null, null, 40]}
    >
      {title && <H1 styleAs="h2">{title}</H1>}
      {children}
    </CenteredLayoutContainer>
  </Layout>
);

export default CenteredLayout;
